<template>
  <!-- RIGHT COLUMN CONTENT PAGE -->

  <div class="my-4 lg:my-0">
    <consulting :coworker="coworker" small />

    <portal-target name="above-locations" />

    <div class="hidden lg:block">
      <h3 class="pt-0 lg:pt-5 pb-2 font-semibold text-xl uppercase">
        Besuchen Sie uns vor Ort
      </h3>
      <Shops class="wow fadeIn" />
    </div>
  </div>
</template>
<script>
import Shops from '~/components/cardtypes/Shops'

export default {
  components: {
    Shops,
  },
  props: {
    coworker: {
      type: Object,
      default: null,
    },
  },
}
</script>
